<template>
  <!-- Modal Popup for Load Image -->
  <div v-if="showModal" class="modal">
      <div class="modal-content">
          <h3 class="modal-header">Load Image</h3>
          <input type="file" class="modal-input" @change="onFileChange" accept="image/*" />
          <p v-if="error" class="modal-error">{{ error }}</p>
          <div class="modal-buttons">
              <button class="modal-button upload-button" @click="uploadImage">Upload</button>
              <button class="modal-button cancel-button" @click="closeModal">Cancel</button>
          </div>
      </div>
  </div> 
</template>

<script>

export default {
name: 'ImageUploader',
props: {
  showModal: {
    type: Boolean,
    required: true,
  },
},

emits: ['imageChanged', 'closeModal'],

data() {
  return {
    selectedFile: null,
    error: null,
    maxFileSize:  10 * 1024 * 1024, // 10MB
  };
},

methods: {
  async uploadImage() {
    if (!this.selectedFile) {
      this.error = "Please select a valid image.";
      return;
    }

    this.$emit('imageChanged', this.selectedFile);
    this.closeModal(); // Close the modal after upload
  },

  closeModal() {
    // Notify the parent component to close the modal
    this.$emit('closeModal');
    this.selectedFile = null;
    this.error = null;
  },

  onFileChange(event) {
    const file = event.target.files[0];
    if (file) {
      if (file.size > this.maxFileSize) {
        this.error = `File size should not exceed ${this.maxFileSize / (1024 * 1024)} MB.`;
        this.selectedFile = null;
      } else {
        this.error = null;
        this.selectedFile = file;
      }
    }
  },
},
};
</script>

<style scoped>
/* Modal container */
.modal {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.5);
display: flex;
justify-content: center;
align-items: center;
z-index: 1000;
}

/* Modal content box */
.modal-content {
background-color: #ffffff;
padding: 20px;
border-radius: 8px;
width: 400px;
max-width: 90%;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
text-align: center;
}

/* Modal header */
.modal-header {
font-size: 1.5rem;
margin-bottom: 20px;
color: #333333;
}

/* File input styling */
.modal-input {
margin: 20px 0;
font-size: 1rem;
}

/* Error message */
.modal-error {
color: #ff4d4f;
font-size: 0.9rem;
margin-top: 10px;
}

/* Buttons container */
.modal-buttons {
display: flex;
justify-content: space-between;
margin-top: 20px;
}

/* Buttons */
.modal-button {
padding: 10px 20px;
font-size: 1rem;
border: none;
border-radius: 5px;
cursor: pointer;
transition: background-color 0.3s;
}

.upload-button {
background-color: #4caf50;
color: white;
}

.upload-button:hover {
background-color: #45a049;
}

.cancel-button {
background-color: #f44336;
color: white;
}

.cancel-button:hover {
background-color: #d32f2f;
}
</style>
